import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        key: 'photo',
        label: 'photo',
        customRender: true,
        defaultShow: true,
        disableFilter: true,
        disableSort: true,
        customStyle: { padding: '1px 1px 1px 1px' },
    },
    {
        key: 'USER_ID',
        label: 'id',
        type: 'number',
        defaultShow: true,
    },
    {
        key: 'TIMESTAMP_CREATED',
        label: 'dateCreated',
        type: 'dateTime',
        defaultShow: true,
    },
    {
        key: 'NAME',
        label: 'name',
        defaultShow: true,
    },
    {
        key: 'SURNAME',
        label: 'surname',
        defaultShow: true,
    },
    {
        key: 'USER_EMAIL',
        label: 'emailAddress',
        defaultShow: true,
    },
    {
        key: 'rolesText',
        label: 'role',
        defaultShow: true,
        type: 'multi-select',
        selectOption: 'roleCodes',
    },
    {
        key: 'active',
        label: 'status',
        customRender: true,
        defaultShow: true,
        type: 'select',
        selectOption: 'activeCodes',
        customStyle: { padding: '1px 11px 1px 16px' },
    },
    {
        key: 'SKLADON_USER',
        label: 'skladonUser',
        defaultShow: true,
        type: 'select',
        selectOption: 'boolNumberCodes',
        customRender: true,
    },
    {
        key: 'USERS_PROVIDERS',
        label: 'eshops',
        defaultShow: true,
        customRender: true,
    },
    {
        key: 'PHONE',
        label: 'phone',
        defaultShow: false,
    },
    {
        key: 'LAST_LOGIN',
        label: 'lastLogin',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'LAST_CHANGED_PASSWORD',
        label: 'lastChangedPassword',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'CREATOR',
        label: 'creatorId',
        type: 'number',
        defaultShow: false,
    },
    {
        key: 'LANG',
        label: 'lang',
        type: 'select',
        selectOption: 'langCodes',
        defaultShow: false,
    },
];
